import "pixi";
import "phaser";

import * as i18n from "../i18n";

export default class MuteButton extends Phaser.Group {
    game: Phaser.Game;
    sound_on: Phaser.Sprite;
    sound_off: Phaser.Sprite;
    sound_active: boolean;
    sound_tween: Phaser.Tween | null;
    callbackOn: () => void;
    callbackOff: () => void;

    constructor(game: Phaser.Game, callbackOff: () => void, callbackOn: () => void, fadeDelay: number, parent?: Phaser.Group) {
        super(game, parent);
        this.game = game;
        this.callbackOn = callbackOn;
        this.callbackOff = callbackOff;

        let sound_storage = localStorage.getItem("sound");
        if(!sound_storage){
            this.sound_active = true;
        }
        else{
            this.sound_active = (sound_storage == "on");
        }

        this.sound_on = this.game.add.sprite(774, 30, "sound_on");
        this.sound_on.anchor.setTo(0.5, 0.5);
        this.sound_on.alpha = 0;
        this.sound_on.tint = 0xaaaaaa;

        this.sound_off = this.game.add.sprite(774, 30, "sound_off");
        this.sound_off.anchor.setTo(0.5, 0.5);
        this.sound_off.alpha = 0;
        this.sound_off.tint = 0xaaaaaa;

        this.addMultiple([this.sound_on, this.sound_off]);

        if(fadeDelay == 0){
            if(this.sound_active){
                this.sound_on.alpha = 1;
            }
            else {
                this.sound_off.alpha = 1;
            }
            this.enableButton();
        }
        else {
            if(this.sound_active){
                this.sound_tween = this.game.add.tween(this.sound_on).to( { alpha: 1 }, 300, "Linear", false);
            }
            else{
                this.sound_tween = this.game.add.tween(this.sound_off).to( { alpha: 1 }, 300, "Linear", false);
            }
            this.sound_tween.delay(fadeDelay);
            this.sound_tween.onComplete.add(() => {this.enableButton();});
            this.sound_tween.start();
        }
    }

    storeSound() {
        let sound_storage = (this.sound_active) ? "on" : "off";
        localStorage.setItem("sound", sound_storage);
    }

    enableButton() {
        this.sound_on.inputEnabled = true;
        this.sound_on.input.useHandCursor = true;
        this.sound_on.events.onInputOver.add(this.onHover, this);
        this.sound_on.events.onInputOut.add(this.outHover, this);
        this.sound_on.events.onInputDown.add(this.onClick, this);
        this.sound_on.inputEnabled = this.sound_active;
        if(this.sound_active) this.callbackOn();

        this.sound_off.inputEnabled = true;
        this.sound_off.input.useHandCursor = true;
        this.sound_off.events.onInputOver.add(this.onHover, this);
        this.sound_off.events.onInputOut.add(this.outHover, this);
        this.sound_off.events.onInputDown.add(this.onClick, this);
        this.sound_off.inputEnabled = !this.sound_active;
        if(!this.sound_active) this.callbackOff();
    }

    onHover(item: Phaser.Sprite) {
        this.sound_on.tint = 0xffffff;
        this.sound_off.tint = 0xffffff;
    }

    outHover(item: Phaser.Sprite) {
        this.sound_on.tint = 0xaaaaaa;
        this.sound_off.tint = 0xaaaaaa;
    }

    onClick(item: Phaser.Sprite){
        if(this.sound_active){
            this.sound_on.alpha = 0;
            this.sound_off.alpha = 1;
            this.sound_active = false;
            this.sound_on.inputEnabled = false;
            this.sound_off.inputEnabled = true;
            this.callbackOff();
        }
        else {
            this.sound_on.alpha = 1;
            this.sound_off.alpha = 0;
            this.sound_active = true;
            this.sound_off.inputEnabled = false;
            this.sound_on.inputEnabled = true;
            this.callbackOn();
        }
        this.storeSound();
    }
}



// WEBPACK FOOTER //
// ./src/ui/mute.ts